/**
 * @file
 * Simple helpers for the ymca_denver_lb theme.
 */

(function ($, Drupal, drupalSettings, once) {

  'use strict';

})(jQuery, Drupal, drupalSettings, once);
